import { DatePipe } from "@angular/common";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
/**
 * Validador de FormControl para verificar si una fecha se encuentra disponible en el intervalo de dos fechas recibidas por parámetro
 * @param fechaInicio Fecha de inicio del intervalo
 * @param fechaFin Fecha de fin de intervalo 
 * @returns error de nombre FechaEnIntervalo de valor false
 * TODO: Para usar el método inyectar el validador en el campo de fecha e ingresar las fechas de inicio y fin. 
 * fechaIdentificacion: ['', [Validators.required, validadorFechaIntervalo(new Date('08/01/2023'), new Date('08/19/2023'))]],
 */
export function validadorFechaIntervalo(fechaInicio: string, fechaFin: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (fechaInicio && fechaFin) {
      const date = control?.value;
      let _fechaInicio = new Date(fechaInicio.replace(/-/g, '\/'));
      let _fechaFin = new Date(fechaFin.replace(/-/g, '\/'))

      if (date) {
        const newDate = new Date(date.replace(/-/g, '\/'))
  
        return newDate <= _fechaFin && newDate >= _fechaInicio ? null : { fechaInicio: _fechaInicio.getDate()+"/"+(_fechaInicio.getMonth()+1)+"/"+_fechaInicio.getFullYear(), fechaFin: _fechaFin.getDate()+"/"+(_fechaFin.getMonth()+1)+"/"+_fechaFin.getFullYear() };
      }
    }
    return null
  };
}


/**
 * 
 * @param control 
 * @returns 
 */
export const validadorFormularioFechas: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  const fechaInicio = control.get('fechaInicio');
  const fechaFin = control.get('fechaFin');
  const objetivo: any = control.get('idSprObjetivo').value;

  if (fechaInicio.value && fechaFin.value && objetivo) {
    let _fechaInicio = new Date(fechaInicio.value.replace(/-/g, '\/'));
    let _fechaFin = new Date(fechaFin.value.replace(/-/g, '\/'))

    let _fechaObjetivoInicio = new Date(objetivo.fechaInicio.replace(/-/g, '\/'))
    let _fechaObjetivoFin = new Date(objetivo.fechaFin.replace(/-/g, '\/'))

    if (_fechaInicio <= _fechaFin) {
      if (_fechaInicio >= _fechaObjetivoInicio && _fechaInicio <= _fechaObjetivoFin) {
        if (_fechaFin >= _fechaObjetivoInicio && _fechaFin <= _fechaObjetivoFin) {
          return null
        } else {
          return { error: true, mensaje: `La fecha de fin debe estar entre ${objetivo.fechaInicio} y ${objetivo.fechaFin}` }
        }
      } else {
        return { error: true, mensaje: `La fecha de inicio ${fechaInicio.value} debe estar entre ${objetivo.fechaInicio} y ${objetivo.fechaFin}` }
      }
    } else {
      return { error: true, mensaje: `La fecha de inicio debe ser anterior a la fecha fin` }
    }
  } else {
    return null
  }
};



/**
 * Validador de FormControl para verificar si una fecha se encuentra disponible en el intervalo de dos fechas recibidas por parámetro
 * @param fechaMaxima Fecha máxima de validación 
 * @returns error de nombre FechaEnIntervalo de valor false
 * TODO: Para usar el método inyectar el validador en el campo de fecha e ingresar las fechas de inicio y fin. 
 * fechaIdentificacion: ['', [Validators.required, validadorFechaIntervalo(new Date('08/01/2023'), new Date('08/19/2023'))]],
 */
export function validadorFechaMenorIgual(fechaMaxima: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control?.value;
    if (date) {
      const newDate = new Date(date.replace(/-/g, '\/'))
      return newDate <= fechaMaxima ? null : { fechaMenor: false };
    }
    return null
  };
}



/**
 * Validador de FormControl para verificar si una fecha se encuentra disponible en el intervalo de dos fechas recibidas por parámetro
 * @param fechaMínima Fecha mínima para cumplir con la condición 
 * @returns fechaMayor es decir que la fecha ingresada es menor a la fecha mínima solicitada
 * TODO: Para usar el método inyectar el validador en el campo de fecha e ingresar la fecha mínima a evaluar 
 */
export function validadorFechaMayorIgual(fechaMinima: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control?.value;
    if (date) {
      const newDate = new Date(date.replace(/-/g, '\/'))
      return newDate >= fechaMinima ? null : { fechaMayor: false };
    }
    return null
  };
}


/**
 * Validador de FormControl para verificar si una fecha se encuentra disponible en el intervalo de dos fechas recibidas por parámetro
 * @param nombreControlador Nombre del input fecha del FormControl
 * @param abstractControl inyectar el formulario para obtener el campo
 * @returns fechaInconsistente cuando la fecha de Inicio no sea menor que la de fin 
 * TODO: Para usar el método inyectar el validador en el campo de fecha e ingresar abtractControl que es el formulario completo y nombreControler que es el nombre del controlador con el que se desea valiar el fin
 */
export function validadorFechaInicioEsMenorQueFin(abstractControl: AbstractControl, nombreControlador: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control?.value;
    const dateFin = abstractControl.get(nombreControlador)?.value;

    if (date && dateFin) {
      const newDateInicio = new Date(date.replace(/-/g, '\/'))
      const newDateFin = new Date(dateFin.replace(/-/g, '\/'))
      return newDateInicio <= newDateFin ? null : { fechaInconsistente: false };
    }
    return null
  };
}



/**
 * Validador de FormControl para verificar si una fecha se encuentra disponible en el intervalo de dos fechas recibidas por parámetro
 * @param nombreControlador Nombre del input fecha del FormControl
 * @param abstractControl inyectar el formulario para obtener el campo
 * @returns fechaInconsistente cuando la fecha de Inicio no sea menor que la de fin 
 * TODO: Para usar el método inyectar el validador en el campo de fecha e ingresar abtractControl que es el formulario completo y nombreControler que es el nombre del controlador con el que se desea valiar el fin
 */
export function validadorFechaFinEsMayorQueInicio(abstractControl: AbstractControl, nombreControlador: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control?.value;
    const dateFin = abstractControl.get(nombreControlador)?.value;

    if (date && dateFin) {
      const newDateInicio = new Date(date.replace(/-/g, '\/'))
      const newDateFin = new Date(dateFin.replace(/-/g, '\/'))
      return newDateInicio >= newDateFin ? null : { fechaInconsistente: false };
    }
    return null
  };
}